var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropDownModular',{attrs:{"options":_vm.options,"selected":_vm.value},on:{"updateSelected":function($event){return _vm.$emit('selectZoom', $event)}},scopedSlots:_vm._u([{key:"head",fn:function(){return [_c('TText',{attrs:{"text":_vm.getPercentageString(_vm.value)}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }